import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { BASE_URL } from '../../../Components/Base_url/Base_Url';
// import Breadcrumb from '../Navbar/Breadcrumb';
import Banner from '../../About Sections/Banner';
import Service_details_cards from './Service_details_cards';
import Banner_deatil from '../../../Components/Banner_Detail/Banner_deatil';

function Service_detals() {
    const { id } = useParams();
    const [Details, setDetails] = useState([]);
    const [DetailsLoading, setDetailsLoading] = useState(true);

    const fetchDetails = async () => {
        try {

            const response = await fetch(`${BASE_URL}/service_details/${id}/`);

            const data = await response.json();
            console.log("Fetched Data:", data);
            if (data?.data) {
                console.log("Details:", data.data);
                setDetails(data.data);

            }
        } catch (error) {
            console.error("Error fetching slides:", error);
        } finally {
            setDetailsLoading(false);
        }
    };
    console.log("Details", Details)

    useEffect(() => {
        fetchDetails();
    }, [id]);
    return (
        <>
            {

                Details.map((detail) => (
                    <>
                        <Banner_deatil Banner={detail.banner} Serviceloading={DetailsLoading} name={detail.name} slug={detail.slug} />

                        <Service_details_cards detail={detail} DetailsLoading={DetailsLoading} />
                    </>
                ))
            }


        </>
    )
}

export default Service_detals